import React from "react";
import BgPick from "../../images/pickDrop.png";
import BackButton from "../bars/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import Skeleton from "../../components/skeletons/skeleton";
import { convert_24_to_12 } from "../../utils/util";
import { InRoomRestaurantPageView } from "../../utils/Analytics";

function Resturants() {
  const navigate = useNavigate();
  const location = useLocation();

  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const hotelId = urlArray[urlArray.length - 1];

  const [restaurantData, SetRestaurantData] = useState([]);
  const [hotelData, SethotelData] = useState([]);
  const [restaurantHide, SetrestaurantHide] = useState(true);
  localStorage.setItem("hotel-id", hotelId);
  const [IsLoading, SetLoading] = useState(true);
  let [isOpen, setIsOpen] = useState(false);

  const getResList = async () => {
    SetLoading(true);
    try {
      await axios({
        method: "get",
        url: `${baseURL}/api/restaurants/` + hotelId,

        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        if (response.data.data.length == 0) {
          setIsOpen(true);
        }
        SetLoading(false);
        SetRestaurantData(response.data.data);
        SethotelData(response.data.data);
      });
    } catch {
        SetLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    InRoomRestaurantPageView();
    getResList();
  }, []);

  return (
    <div>
    {!IsLoading ?  <div className="mb-28">
        <div className="section-wrap mx-4 pt-6">
          <div className="flex items-center space-x-3">
            <BackButton />
            <div className="guestName sm:text-center text-left">
              Indoor Dining
            </div>
          </div>
          <div>
            <div className="gridTab grid grid-flow-row sm:grid-cols-2 grid-cols-1 gap-3 gap-x-4 mt-6">
              {restaurantHide
                ? restaurantData.map((restaurantData, index) => (
                    <Link
                      key={index}
                      to={"../food-items/" + hotelId + "-" + restaurantData.id}
                      type="button"
                      state={restaurantData}
                      className="flex flex-row sm:flex-col items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                    >
                      <div className="sm:w-full flex bg-gray-200 rounded-md overflow-hidden sm:h-[160px] w-[56px] h-[56px] ">
                      <img
                          width="100%"
                          height="100%"
                          className={`flex items-stretch bg-contain object-cover transition w-full sm:h-full ${
                            restaurantData?.open_kitchen == 1 ? "" : "filter grayscale" }`}
                          src={restaurantData?.image}
                          alt="hotelGuide"
                        ></img>
                      </div>
                      <div className="flex-col pl-[10px] sm:pl-0 w-full flex">
                        <div className="sm:mt-2 mt-0 sm:text-base text-[14px] font-medium">
                          {restaurantData.restaurant_name}
                        </div>
                        {(restaurantData?.start_time && restaurantData?.close_time) ?  <div className="mt-1 text-left text-[10px] text-[#9A9A9A] font-medium">
                           Working hours : {convert_24_to_12(restaurantData?.start_time ? restaurantData?.start_time:'')} - {convert_24_to_12(restaurantData?.close_time ? restaurantData?.close_time:'')}
                        </div> : "" }
                        {/* {restaurantData?.start_time  !=  restaurantData?.close_time ? <div className="mt-1 text-left text-[10px] text-[#9A9A9A] font-medium">
                           Working hours : {convert_24_to_12(restaurantData?.start_time ? restaurantData?.start_time:'')} - {convert_24_to_12(restaurantData?.close_time ? restaurantData?.close_time:'')}
                        </div> : <div>{restaurantData?.open_kitchen == 1 ? <div className="mt-1  text-left text-[11px] text-[#9A9A9A] font-medium"> Working hours : 24x7</div>:<div className="mt-1  text-left text-[11px] text-[#9A9A9A] font-medium"> Currently unavailable</div>}</div> } */}
                      </div>
                    </Link>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
      :
      <Skeleton type="page"/>}
    </div>
  );
}

export default Resturants;
